var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncommonM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6289 3L10.6289 4.37106H9.25763V5.74229H10.6289L10.6289 4.37123H13.434V3H10.6289ZM13.441 4.37106V5.74229H14.8122V4.37106H13.441ZM13.441 9.24352V10.6148H14.8122V9.24352H13.441ZM10.6289 13.4201V14.7701H9.25763V13.3988H10.6289V10.6149H13.434L13.434 13.392H14.8053V14.7633H13.434L13.434 13.4201H10.6289ZM13.434 19.6215V18.2502H14.8053V19.6215H13.434ZM14.8122 14.7701V18.2504H16.1834V16.1411H18.3274V14.7701H19.6917V13.3988H18.3204V14.7699H14.9585V14.7701H14.8122ZM7.8864 18.2572V16.1622H5.74943V14.791H9.25758V15.1388H9.25767V18.2572H7.8864ZM9.25763 18.2577V19.6289H10.6289V18.2577H9.25763ZM9.25763 10.6148V9.24352H10.6289V10.6148H9.25763ZM4.3782 9.24352V10.6148H5.74943V9.24352H4.3782ZM4.37123 14.7633V13.4199H3V10.6148H4.37125V13.392H5.7425V14.7633H4.37123ZM18.3274 10.6148V9.24352H19.6986V10.6148H18.3274ZM19.6986 10.6148H21.0699V13.4199H19.6986V10.6148ZM10.6358 21V19.6288H13.4409V21H10.6358ZM14.8262 9.23621H18.3065V7.86498H16.1974V5.72793H14.8262V7.86498V9.09686V9.23621ZM9.25763 9.22942V5.74909H7.8864V7.85836H5.7425V9.22959H9.11148V9.22942H9.25763Z",
    fill: "#25EF52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncommonM);
export default __webpack_public_path__ + "static/media/uncommon-m.9af7f4718f043e2c9f3944ff94408fca.svg";
export { ForwardRef as ReactComponent };